module.exports = __webpack_public_path__ + "img/WPS.b25a55b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advancedVersion/WPS.png
// module id = 4n+3
// module chunks = 2 3 6 8 15 49